import { render } from "./BuyerForm.vue?vue&type=template&id=173eefa6"
import script from "./BuyerForm.vue?vue&type=script&lang=js"
export * from "./BuyerForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__